import { createTeamsDarkTheme } from "../../utils/createTeamsDarkTheme.js";
import { brandTeams } from "../../global/brandColors.js";
import { fontFamilies } from "../../alias/teamsFontFamilies.js";
export const teamsDarkTheme = {
    ...createTeamsDarkTheme(brandTeams),
    ...fontFamilies
};
